import React from 'react';
import { Switch, Route } from 'react-router-dom';
import List from './List';
import Detail from './Detail';
import { AddBroadcasts } from './Add';

export default function BroadcastsRoutes({ match }) {
  return (
    <Switch>
      <Route exact path={match.url} component={List} />
      <Route path={`${match.url}/add`} component={AddBroadcasts} />
      <Route path={`${match.url}/:topicSlug`} component={Detail} />
    </Switch>
  );
}
